import gql from 'graphql-tag';

import { useAdminMeetingListViewQuery } from '@/@generated/codegen/API';
import { useEntitySubscription } from '@/hooks/useEntitySubscription';
import { usePaginationState } from '@/hooks/usePaginationState';
import { PageLoading } from '@/ui/PageLoading';
import { usePrevious } from '@/utils/helpers/react.helper';

import AdminMeetingListView from './AdminMeetingListView';
import { useAdminMeetingListQueryParams } from './hooks/useAdminMeetingListQueryParams';

gql`
  query AdminMeetingListView(
    $paginationArgs: PaginationArgs!
    $orderByArgs: OrderByArgs
    $where: MeetingWhereInput
    $clientsPaginationArgs: PaginationArgs
    $teamPaginationArgs: PaginationArgs
    $userMeetingJoinsPaginationArgs: PaginationArgs
    $accessLinkPaginationArgs: PaginationArgs
  ) {
    listMeetings(paginationArgs: $paginationArgs, orderByArgs: $orderByArgs, where: $where) {
      edges {
        node {
          ...MeetingFields
          ...MeetingRelationAccessLink
          ...MeetingRelationHost
          ...MeetingRelationCaseCluster
          ...MeetingRelationClients
          ...MeetingRelationTeams
          ...MeetingRelationUserMeetingJoins
          ...MeetingRelationHostFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

const PAGE_SIZE = 10;
export const meetingTablePrefix = 'meetings';

const AdminMeetingListClient = () => {
  const { paginationArgs, orderByArgs, where } = useAdminMeetingListQueryParams(
    PAGE_SIZE,
    meetingTablePrefix
  );
  const meetings = useAdminMeetingListViewQuery({
    variables: {
      paginationArgs,
      orderByArgs,
      where,
      clientsPaginationArgs: { first: 100 },
      teamPaginationArgs: { first: 100 },
      userMeetingJoinsPaginationArgs: { first: 100 },
    },
  });
  const previousData = usePrevious(meetings.data);
  const pagination = usePaginationState(PAGE_SIZE, meetingTablePrefix);

  useEntitySubscription('Meeting', {
    onCreate: {
      variables: {
        where,
      },
      onData: () => {
        void meetings.refetch();
      },
    },
    onUpdate: {
      variables: {
        where,
      },
      onData: () => {
        void meetings.refetch();
      },
    },
    onDelete: {
      variables: {},
      onData: () => {
        void meetings.refetch();
      },
    },
  });

  if (!previousData && !meetings.data) {
    return <PageLoading />;
  }
  return (
    <AdminMeetingListView
      data={meetings.data || previousData!}
      pagination={pagination}
      tablePrefix={meetingTablePrefix}
    />
  );
};

export default AdminMeetingListClient;
